import { render, staticRenderFns } from "./ExtraForm.vue?vue&type=template&id=13d4f5b4&scoped=true"
import script from "./ExtraForm.vue?vue&type=script&lang=js"
export * from "./ExtraForm.vue?vue&type=script&lang=js"
import style0 from "./ExtraForm.vue?vue&type=style&index=0&id=13d4f5b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d4f5b4",
  null
  
)

export default component.exports